<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="exchange_rate">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm10 md9 elevation-6>
                <div class="sub-window">
                    <v-toolbar dense dark color="teal darken-3">
                        <v-toolbar-title>Reportes - {{ company.nombre }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items class="hidden-sm-and-down">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn text @click="onCancel" v-on="on">
                                        <v-icon>cancel</v-icon>
                                    </v-btn>
                                </template>
                                <span>Cancelar</span>
                            </v-tooltip>
                        </v-toolbar-items>

                        <!-- Menú lateral para dispositivos con ventanas chicas: -->
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" class="hidden-md-and-up">
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list color="grey lighten-5">
                                <v-divider></v-divider>
                                <v-list-item @click="onCancel">
                                    <v-list-item-title>
                                        <v-icon color="teal darken-1">cancel</v-icon>&nbsp; Cancelar
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar>

                    <!-- Container para Información: -->
                    <v-container pa-2 grid-list-md>
                        <!-- Renglón único para Información: -->
                        <v-layout row>
                            <v-flex xs12>
                                <v-card color="grey lighten-5">
                                    <v-card-text>
                                        <v-container fluid pa-1>
                                            <!-- <v-layout row>
                                                <v-flex class="title">Tipo de Valuación:</v-flex>
                                            </v-layout>-->
                                            <v-layout row wrap justify-space-between>
                                                <v-flex
                                                    xs4
                                                    sm3
                                                    class="title pt-sm-5"
                                                >Tipo de Reporte:</v-flex>
                                                <v-flex xs8 sm5>
                                                    <v-radio-group
                                                        v-model="reportType"
                                                        :mandatory="true"
                                                        row
                                                    >
                                                        <v-radio
                                                            label="General"
                                                            value="0"
                                                            color="orange accent-4"
                                                            @change="onCompany"
                                                        ></v-radio>
                                                        <v-radio
                                                            label="Por Dirección"
                                                            value="1"
                                                            color="orange accent-4"
                                                            @change="onDepartments"
                                                        ></v-radio>
                                                    </v-radio-group>
                                                </v-flex>
                                                <v-flex xs12 sm4>
                                                    <v-select
                                                        :disabled="reportType === '0'"
                                                        :items="userDepartments"
                                                        prepend-icon="party_mode"
                                                        item-text="nombreUsuario"
                                                        item-value="usuariosdireccionesid"
                                                        v-model="departmentID"
                                                        label="Dirección"
                                                        color="teal darken-3"
                                                        item-color="teal darken-3"
                                                        no-data-text="No hay direcciones asignadas"
                                                    ></v-select>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout align-center justify-end row fill-height>
                                                <v-flex xs12 sm8 class="text-xs-center text-end">
                                                    <v-btn
                                                        color="teal darken-3"
                                                        class="text-none"
                                                        text
                                                        @click="onReports"
                                                    >Generar Reportes</v-btn>
                                                    <v-btn
                                                        color="pink darken-1"
                                                        class="text-none"
                                                        text
                                                        @click="onCancel"
                                                    >Cancelar</v-btn>
                                                </v-flex>
                                            </v-layout>

                                            <!-- Modal para pedir que se introuzcan todos los campos: *********************************** -->

                                            <v-layout row justify-center>
                                                <v-dialog
                                                    v-model="bInvalidData"
                                                    persistent
                                                    :max-width="errorModalWidth"
                                                >
                                                    <v-card class="grey lighten-4">
                                                        <v-toolbar dense color="teal" dark flat>
                                                            <v-toolbar-title
                                                                class="my-list-title"
                                                            >Información Incompleta</v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                            <v-icon>error_outline</v-icon>
                                                        </v-toolbar>
                                                        <v-card-title>
                                                            <v-container>
                                                                <v-layout row>
                                                                    <v-flex
                                                                        xs12
                                                                        class="d-flex justify-center"
                                                                    >
                                                                        <v-icon
                                                                            large
                                                                            color="orange darken-2"
                                                                        >warning</v-icon>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-layout row>
                                                                    <v-flex
                                                                        xs12
                                                                        class="d-flex justify-center text-center"
                                                                    >{{ errorMessage }}</v-flex>
                                                                </v-layout>
                                                            </v-container>
                                                        </v-card-title>

                                                        <v-card-actions>
                                                            <v-spacer></v-spacer>
                                                            <v-btn
                                                                color="teal darken-3"
                                                                class="text-none"
                                                                text
                                                                @click="bInvalidData = false"
                                                            >OK</v-btn>
                                                        </v-card-actions>
                                                    </v-card>
                                                </v-dialog>
                                            </v-layout>
                                            <!-- Termina modal para pedir que se introuzcan todos los campos *********************************** -->
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>

                        <!-- Modal para el reporte de valuaciones por empresa: *********************************** -->
                        <!-- Con v-if el componente es destruido cada vez que v-if es falso, con lo que
                        nos aseguramos de que el componente sea creado cada vez que se muestra. Con esto la función
                        created() es llamada en el componente cada vez que v-if es verdadero:-->
                        <v-layout v-if="showCompanyReportResultsDlg" row justify-center>
                            <v-dialog
                                v-model="showCompanyReportResultsDlg"
                                persistent
                                :max-width="resultsModalWidth"
                            >
                                <company-report-results></company-report-results>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para el reporte de valuaciones por empresa *************************** -->

                        <!-- Modal para el reporte de valuaciones por dirección: *********************************** -->
                        <!-- Con v-if el componente es destruido cada vez que v-if es falso, con lo que
                        nos aseguramos de que el componente sea creado cada vez que se muestra. Con esto la función
                        created() es llamada en el componente cada vez que v-if es verdadero:-->
                        <v-layout v-if="showDepartmentReportResultsDlg" row justify-center>
                            <v-dialog
                                v-model="showDepartmentReportResultsDlg"
                                persistent
                                :max-width="resultsModalWidth"
                            >
                                <department-report-results></department-report-results>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para el reporte de valuaciones por dirección *************************** -->
                    </v-container>
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>
        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';
import CompanyReportResults from '@/components/CompanyReportResults';
import DepartmentReportResults from '@/components/DepartmentReportResults';

export default {
    name: 'Reports',
    data() {
        return {
            drawer: false,
            bInvalidData: false,
            errorMessage: '',
            reportType: '0', //0 = company, 1 = department
            departmentID: 0
        };
    },
    components: {
        CompanyReportResults,
        DepartmentReportResults
    },
    created() {},
    methods: {
        onCancel() {
            this.$router.push('/');
        },
        onCompany() {
            //Al parecer el valor this.reportType se actualiza hasta después de
            //terminada esta función, por lo que en la función getSize this.reportType
            //todavía tiene el valor anterior. Por lo tanto, hay que forzar a que
            //this.reportType sea "0":

            this.reportType = '0';
            this.departmentID = 0;
        },

        onDepartments() {
            console.log('onDepartments, reportType = ', this.reportType);
        },

        onReports() {
            if (this.reportType === '1' && this.departmentID === 0) {
                this.bInvalidData = true;
                this.errorMessage = 'Por favor seleccione una dirección.';
            } else {
                if (this.reportType === '0') {
                    //Empresa
                    this.$store.dispatch(
                        'companyReport',
                        this.company.empresaid
                    );
                } else if (this.reportType === '1') {
                    //Dirección
                    var departmentName = '';
                    var i;
                    for (i = 0; i < this.userDepartments.length; i++) {
                        if (
                            this.userDepartments[i].usuariosdireccionesid ===
                            this.departmentID
                        ) {
                            departmentName = this.userDepartments[i]
                                .nombreUsuario;
                            break;
                        }
                    }
                    var selectedDepartment = {
                        name: departmentName,
                        departmentID: this.departmentID
                    };
                    this.$store.dispatch(
                        'departmentReport',
                        selectedDepartment
                    );
                }
            }
        }
    },
    computed: {
        ...mapGetters([
            'waitCursor',
            'company',
            'userDepartments',
            'showCompanyReportResultsDlg',
            'showDepartmentReportResultsDlg'
        ]),

        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        },
        resultsModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '100%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '98%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '90%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '70%';
            }
            return width;
        }
    }
};
</script>

<style scoped>
.sub-window {
    background-color: #e0e0e0; /*grey lighten-2 */
}
.exchange_rate {
    background: url('../assets/photo-1499750310107-5fef28a66643.png');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}
.my-car-table {
    width: 100%;
}
</style>